var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCybersecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500.2 500.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#018b9d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coloured_icons",
    "data-name": "Coloured icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M426.9,73.3A250.1,250.1,0,0,0,0,250.1,250.26,250.26,0,0,0,250.1,500.2,250.26,250.26,0,0,0,500.2,250.1,250.52,250.52,0,0,0,426.9,73.3ZM415.6,415.9A234.37,234.37,0,0,1,84.3,84.3,234.4,234.4,0,0,1,484.5,250.1a232.35,232.35,0,0,1-68.9,165.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M420.1,112.3a7.81,7.81,0,0,0-12,10A203.06,203.06,0,0,1,115,401.5,7.79,7.79,0,1,0,104.5,413a218.31,218.31,0,0,0,300.4-8.4,217.05,217.05,0,0,0,64.2-154.8,221.7,221.7,0,0,0-49-137.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.8,250.1c0-111.8,91.1-203,203.2-203A202.86,202.86,0,0,1,385.4,98.7a7.79,7.79,0,0,0,10.5-11.5A218.69,218.69,0,0,0,95.2,95.6,216.36,216.36,0,0,0,31,250.1,219.83,219.83,0,0,0,79.7,387.9a8,8,0,0,0,6,2.9,7.8,7.8,0,0,0,6-12.8A206.55,206.55,0,0,1,46.8,250.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244,249.8l-23.3-23.3-28.8,28.8L244,307.4l73.1-72.8-28.8-28.8Zm53-15.1-53,52.9-32-32.2,8.6-8.6,23,23.3,44-44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M388.4,172.1c-.3-8.9-.3-17.3-.3-25.7v-7.9h-7.3c-50.6,0-89.1-14.1-121.3-45.3l-5-4.7-5,4.5c-32.2,31.2-70.7,45.6-121.3,45.6h-7.3v7.9c0,8.4,0,17-.3,25.4-.8,42.2-1.6,89.8,14.4,133.3,18.9,50.8,57.1,85.6,117.1,106.3l2.4.8,2.4-.8c60-20.7,98.2-55.5,117.1-106.3C389.9,261.9,389.1,214.2,388.4,172.1ZM254.5,397.6c-122.8-43.7-121-144.3-119.4-225.2,0-6.5.3-12.6.3-18.9,48.7-1.3,86.7-15.7,119.2-45,32.5,29.6,70.5,44,119.2,45,0,6,.3,12,.3,18.3v.5C375.5,253.3,377.4,353.6,254.5,397.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCybersecurity);
export default __webpack_public_path__ + "static/media/Cybersecurity.15d5469b1e55fae3ac2aec6790b6c359.svg";
export { ForwardRef as ReactComponent };